module.exports = __webpack_public_path__ + "img/c3dcc23.png";